import React from 'react';
import Affiliates from '../components/Affiliates';

const AffiliatesPage = () => {
  return <Affiliates />;
};

export default AffiliatesPage;

